import { createRouter, createWebHistory } from "vue-router";
// import DashboardPage from "@/views/DashboardPage.vue";
import DashboardPage from "@/views/Dashboard.vue";
import SettingsPage from "@/views/Settings.vue";
import MediaLinks from "@/components/chat/mediaLinks/MediaLinks.vue";
import HelpPage from "@/views/Help.vue";

import auth from "./auth.js";
import consumers from "./consumers.js";
import workers from "./workers.js";
import projects from "./projects.js";
import services from "./services.js";

const routes = [
    {
        path: "/",
        name: 'Home',
        component: DashboardPage,
    },
    {
        path: "/settings",
        name: "SettingsPage",
        component: SettingsPage,
    },
    {
        path: "/help",
        name: "HelpPage",
        component: HelpPage,
    },
    {
        path: "/medialinks/:projectId",
        name: "MediaLinks",
        component: MediaLinks,
        props: true,
    },
    ...auth,
    ...consumers,
    ...workers,
    ...projects,
    ...services,
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
